import { __awaiter, __generator } from "tslib";
import { createButtonDriver } from '../../new-libby/core/button/driver';
import { createTextInputDriver } from '../../new-libby/core/inputs/text-input/driver';
import { createToggleDriver, popoverDriver } from '../../primitives/drivers';
import { compKey } from './key';
export var createSortableInputListItemDriver = function (wrapper, global, idx) {
    if (idx === void 0) { idx = 0; }
    var base = wrapper.$$("." + compKey).get(idx);
    var popover = popoverDriver(global);
    var textInputDriver = createTextInputDriver(base);
    var toggleDriver = createToggleDriver(base);
    return {
        textInputDriver: textInputDriver,
        clickRemoveButton: function () { return createButtonDriver(base).click(); },
        clickAddButton: function () { return createButtonDriver(base, 0, "." + compKey + "-add-button").click(); },
        closePopover: function () {
            var cancelButton = createButtonDriver(popover, 0, "." + compKey + "-cancel-item-btn");
            return cancelButton.click();
        },
        isDeletePopoverDisplayed: function () { return popover.exists(); },
        setValue: function (value) { return textInputDriver.set(value); },
        getValue: function () { return textInputDriver.value(); },
        isDisabled: function () { return textInputDriver.disabled(); },
        selectItem: function () { return base.$('.drag-icon').click(); },
        isRemoveDisabled: function () {
            var removeButton = createButtonDriver(base);
            return removeButton.base.hasClass('disabled');
        },
        deleteListItem: function () { return __awaiter(void 0, void 0, void 0, function () {
            var deleteButton;
            return __generator(this, function (_a) {
                deleteButton = createButtonDriver(popover, 0, "." + compKey + "-confirm-remove-btn");
                return [2 /*return*/, deleteButton.click()];
            });
        }); },
        isArrowIconExists: function () { return base.$("." + compKey + "-arrow").exists(); },
        hasErrorOnCurrentValue: function () { return base.hasClass('current-value-error'); },
        hasErrorsOnValuesInside: function () { return base.hasClass('has-error-inside'); },
        isSelected: function () { return base.hasClass('selected'); },
        isToggled: function () { return toggleDriver.isOn(); },
        toggle: function () { return toggleDriver.toggle(); },
        isToggleDisabled: function () { return toggleDriver.isDisabled(); },
        getTitle: function () { return base.$("." + compKey + "-title").text(); },
        hasTitle: function () { return base.$("." + compKey + "-title").exists(); },
        isChangeOrderDragDisabled: function () { return base.$('.disabled .drag-icon').exists(); },
        isAddLevelButtonDisabled: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, createButtonDriver(base, 0, "." + compKey + "-add-button").isDisabled()];
        }); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map